import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { MaterialOrdemServicoApiService } from "./materiais-ordem-servico/shared/material-ordem-servico-api.service";
import { MaterialService } from "./material/shared/material.service";
import { MaterialCodigoBarraService } from "./material-codigo-barra/shared/material-codigo-barra.service";
import { MaterialEspecificacaoService } from "./material-especificacao/shared/material-especificacao.service";
import {MaterialCodigoBarraListComponent} from "./material-codigo-barra/material-codigo-barra-list/material-codigo-barra-list.component";
import {MaterialEspecificacaoRegisterComponent} from "./material-especificacao/material-especificacao-register/material-especificacao-register.component";
import {MaterialEspecificacaoFormComponent} from "./material-especificacao/shared/material-especificacao-form/material-especificacao-form.component";
import {MaterialEspecificacaoListComponent} from "./material-especificacao/material-especificacao-list/material-especificacao-list.component";
import {MaterialCodigoBarraRegisterComponent} from "./material-codigo-barra/material-codigo-barra-register/material-codigo-barra-register.component";
import {MaterialComponent} from "./material/material.component";
import {MaterialFormComponent} from "./material/material-form/material-form.component";
import {MaterialListComponent} from "./material/material-list/material-list.component";
import {MaterialDetailComponent} from "./material/material-detail/material-detail.component";
import {MaterialEspecificacaoComponent} from "./material-especificacao/material-especificacao.component";
import {MaterialCodigoBarraComponent} from "./material-codigo-barra/material-codigo-barra.component";
import {MaterialCodigoBarraFormComponent} from "./material-codigo-barra/shared/material-codigo-barra-form/material-codigo-barra-form.component";
import {MateriaisRoutingModule} from "./materiais.routing";
import {MateriaisComponent} from "./materiais.component";
import {MaterialTipoApiService} from "./material/material-tipos/shared/material-tipo-api.service";
import {MaterialServicoFormListComponent} from "./material-servico/material-servico-form-list/material-servico-form-list.component";
import {MaterialServicoTableComponent} from "./material-servico/material-servico-table/material-servico-table.component";
import {MaterialServicoApiService} from "./material-servico/shared/material-servico-api.service";

@NgModule({
    imports: [
        SharedModule,
        MateriaisRoutingModule
    ],
    providers: [
        MaterialOrdemServicoApiService,
        MaterialService,
        MaterialCodigoBarraService,
        MaterialEspecificacaoService,
        MaterialTipoApiService,
        MaterialServicoApiService
    ],
    declarations: [
        MateriaisComponent,
        MaterialComponent,
        MaterialFormComponent,
        MaterialListComponent,
        MaterialDetailComponent,
        MaterialEspecificacaoComponent,
        MaterialEspecificacaoRegisterComponent,
        MaterialEspecificacaoFormComponent,
        MaterialEspecificacaoListComponent,
        MaterialCodigoBarraComponent,
        MaterialCodigoBarraRegisterComponent,
        MaterialCodigoBarraFormComponent,
        MaterialCodigoBarraListComponent,
        MaterialServicoFormListComponent,
        MaterialServicoTableComponent
    ],
    exports: [
        MaterialServicoFormListComponent,
        MaterialServicoTableComponent
    ]
})
export class MateriaisModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/materiais.module.ts
 **/